import {useUserStore} from '@/app/shared/state/UserDataModule';
import {EUserRole} from '@/app/shared/state/user-role';

export function usePermission() {
    return {
        hasPermission: (roles: EUserRole[]): boolean => useUserStore().hasRole(roles),
    }
}
